
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[...management-auth]",
      function () {
        return require("private-next-pages/auth/[...management-auth].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/[...management-auth]"])
      });
    }
  